<section class="faq-page flex flex-col font-display w-full max-w-6xl mx-auto p-4 sm:p-6">
  <div class="page-header">
    <div class="min-w-0 flex-1">
      <p class="text-xs font-medium text-slate-500 mb-1">Pusat bantuan</p>
      <h1 class="text-xl sm:text-2xl font-bold text-slate-900 leading-snug">
        Pertanyaan yang sering diajukan
      </h1>
      <p class="text-sm text-slate-500 mt-1 max-w-2xl">
        Panduan penggunaan aplikasi cash advance &amp; reimbursement untuk
        pengajuan, pengecekan status, dan penyelesaian pertanggungjawaban.
      </p>
    </div>
  </div>

  <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
    <aside class="faq-nav">
      <button
        *ngFor="let item of faqItems"
        type="button"
        class="faq-nav__item"
        [class.faq-nav__item--active]="activeId === item.id"
        (click)="selectFaq(item.id)"
      >
        <span class="faq-nav__icon">
          <i class="fa-solid" [ngClass]="item.icon"></i>
        </span>
        <span class="min-w-0 flex-1 text-left">
          <span class="faq-nav__title">{{ item.title }}</span>
          <span class="faq-nav__summary">{{ item.summary }}</span>
        </span>
        <i class="fa-solid fa-chevron-right faq-nav__chevron"></i>
      </button>
    </aside>

    <article class="section-card lg:col-span-2" *ngIf="activeFaq as faq">
      <div class="section-card__header">
        <div class="flex items-center gap-3 min-w-0">
          <span class="section-card__icon">
            <i class="fa-solid" [ngClass]="faq.icon"></i>
          </span>
          <div class="min-w-0">
            <p class="section-card__eyebrow">Topik {{ faq.id }}</p>
            <h2 class="section-card__title">{{ faq.title }}</h2>
          </div>
        </div>
      </div>

      <div class="section-card__body">
        <div class="faq-content">
          <p *ngFor="let paragraph of faq.paragraphs" class="faq-content__text">
            {{ paragraph }}
          </p>

          <ol *ngIf="faq.steps?.length" class="faq-steps">
            <li *ngFor="let step of faq.steps">{{ step }}</li>
          </ol>

          <div *ngIf="faq.nestedBullets" class="faq-nested">
            <p class="faq-content__text">{{ faq.nestedBullets.title }}</p>
            <ul class="faq-bullets">
              <li *ngFor="let item of faq.nestedBullets.items">{{ item }}</li>
            </ul>
          </div>

          <ul *ngIf="faq.bullets?.length" class="faq-bullets">
            <li *ngFor="let item of faq.bullets">{{ item }}</li>
          </ul>
        </div>
      </div>
    </article>
  </div>
</section>
